import React from 'react'
import Navbar from '../navbar/Navbar'

const Header = () => {
  return (
    <Navbar/>
  )
}

export default Header